var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPart3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 1000 1000",
    width: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      flex: "1 1 0%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.038 350.969c-112.366 0-165.922 108.644-165.922 208.355 0 68.401 34.2 119.067 107.155 119.067 61.745 0 106.368-40.2 126.467-96.033h46.9c-28.289 87.8-86.311 135.444-179.322 135.444-95.245 0-148.056-64.022-148.056-158.478 0-119.767 76.633-247.767 208.311-247.767m409.256-2.242c97.478 0 172.667 48.389 173.367 151.778H784.45c.745-18.61-5.21-33.5-15.633-43.878-9.677-9.722-23.077-14.145-40.944-14.889",
    fill: "rgb(124, 0, 47)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPart3);
export default __webpack_public_path__ + "static/media/logo-part-3.0842cc0b9c71088e1503dc8a5273b3f2.svg";
export { ForwardRef as ReactComponent };